import { request, requestRaw } from '../../../global/services/request'
import { ReportParam } from '../store/store'
import moment from 'moment'

export async function getReports() {
  return await request({
    path: `/generalreports`,
    method: 'GET'
  })
}

export async function getReport(reportId: string) {
  return await request({
    path: `/generalreports/${reportId}`,
    method: 'GET'
  })
}

export async function getReportHTML(partnerId: string, reportId: string, params: ReportParam[]) {
  const queryString = params.map(p => p.key + '=' + formatParamValue(p)).join('&')
  return await requestRaw({
    path: `/generalreports/${reportId}/resellers/${partnerId}/run?report_response_type=HTML&` + queryString,
    method: 'GET'
  })
}

export async function getReportExport(partnerId: string, reportId: string, params: ReportParam[], format: 'pdf'|'csv') {
  const queryString = params.map(p => p.key + '=' + formatParamValue(p)).join('&')
  return await request({
    path: `/generalreports/${reportId}/resellers/${partnerId}/export?` + queryString,
    method: 'POST',
    body: {
      export_format: format,
      export_orientation: 'portrait'
    }
  })
}

function formatParamValue(param: ReportParam) {
  if (param.value instanceof Date) {
    return moment(param.value).format("YYYY-MM-DD")
  } else {
    return encodeURIComponent(param.value)
  }
}

